import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"


const Footer = () => {

    return(
        
    <section id="footer" className="bg-white w-screen h-fit aos-init aos-animate" data-aos="fade-up">
        
        <div className="container mx-auto px-4 py-8">
            <div className="flex flex-wrap">
                <div className="w-full md:w-2/6 px-4 text-center">
                    <StaticImage
                    src= "../images/icon.png"
                    alt="Icone do Sistema wEstoque - PDV online, financeiro e fiscal"
                    placeholder="blurred"
                    layout="fixed"
                    quality={100}
                    width={70}
                    className="h-12 mx-auto"
                    />
                </div>
                <div className="w-full md:w-1/6 px-4 pt-5 md:pt-0">
                    <h1 className="text-xl text-bolder text-westoque-900"><a href="/recursos">Recursos</a></h1>
                    <ul className="list-inside text-westoque-400 text-bold">
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="/controle-de-vendas-e-pdv">Controle de Vendas & PDV</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="/gerencie-multi-empresas">Multi Empresas / Lojas</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="/controle-de-estoques">Controle de Estoques</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="/sistema-financeiro">Sistema Financeiro</a></li>
                    </ul>
                </div>
                <div className="w-full md:w-1/6 px-4 pt-5 md:pt-0">
                    <h1 className="text-xl text-bolder text-westoque-900">Suporte</h1>
                    <ul className="list-inside text-westoque-400 text-bold">
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="/precos">Planos & Preços</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="https://ajuda.westoque.com.br" rel="noreferrer" target="_blank">Manuais / Ajuda</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="https://www.westoque.com.br/blog/" rel="noreferrer" target="_blank">Blog</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="https://ajuda.westoque.com.br/chamado" rel="noreferrer" target="_blank">Contato</a></li>
                    </ul>
                </div>
                <div className="w-full md:w-1/6 px-4 pt-5 md:pt-0">
                    <h1 className="text-xl text-bolder text-westoque-900">Vendas</h1>
                    <ul className="list-inside text-westoque-400 text-bold">
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="https://api.whatsapp.com/send?phone=5541991543922&text=Oi%2C%20quero%20saber%20mais%20sobre%20o%20wEstoque" rel="noreferrer" target="_blank" aria-label="WhatsApp">(41) 99154-3922<br/><span className="text-green-600 cursor-help text-sm"><span role="img" aria-label="whatsapp emoji">💬</span>&nbsp; Whatsapp</span></a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="mailto:vendas@westoque.com.br" rel="noreferrer">vendas@westoque.com.br</a></li>
                    </ul>
                    <h1 className="text-xl text-bolder text-westoque-900 pt-4">Siga-nos</h1>
                    <ul className="list-inside text-westoque-400 text-bold">
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="https://www.facebook.com/westoque.com.br" rel="noreferrer" target="_blank">Facebook</a></li>
                        <li className="mt-2 mr-2 hover:underline cursor-pointer"><a href="https://instagram.com/sistemawestoque" rel="noreferrer" target="_blank">Instagram</a></li>
                    </ul>

                </div>
                
            </div>
        </div>
    </section>
    )
}

export default Footer